import React from 'react';
import Header from '../components/Header';
import About from '../components/About';
import Footer from '../components/Footer';

const AboutPage: React.FC = () => {
    return (
        <div>
            <Header />
            <About />
            <Footer />
        </div>
    );
};

export default AboutPage;